import React, { Component } from 'react';
import { Button, Divider, Form, Icon } from 'semantic-ui-react';
import { Accordion, Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { DatePickerField } from 'Common/SemanticWrapper';
import { DATE_FORMAT_FOR_UI, printOptions } from 'Common/Constants';
import { TransactionSummaryEnum } from 'Common/FieldEnum';
import TransactionSummaryGridContainer from './../../containers/transactionSummaryList/TransactionSummaryGridContainer';
import { TRANSACTION_SUMMARY_LIST_FORM_NAME } from 'Common/FormEnum';
import { DatePickerCustomButton } from 'Components';
import { getDates } from 'Common/FormHelper';

class TransactionSummaryListComponent extends Component {
  render() {
    const {
      transactionSummaryDates,
      onChangeOfFromDT,
      fromDateMax,
      toDateMin,
      onChangeOfToDT,
      printOptionsValue,
      printTransactionSummary,
      handleCollapsePanelClick,
      activeIndexes,
      fetchTransactionSummaryDateLoading,
      fetchExistingTranSummaryPrintLoading,
      clearFilters,
      setReactTableWrapperInstance,
      reactTableRef,
    } = this.props;

    return (
      <Form>
        <Accordion fluid styled>
          <Accordion.Title
            active={activeIndexes.indexOf(0) !== -1}
            index={0}
            onClick={handleCollapsePanelClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Filter By</span>
          </Accordion.Title>
          <Accordion.Content active={activeIndexes.indexOf(0) !== -1}>
            <Grid className="grid-spacing">
              <Grid.Row columns={4}>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    customInput={<DatePickerCustomButton />}
                    label={'Begin Date:'}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    name={TransactionSummaryEnum.BeginDT}
                    onChange={onChangeOfFromDT}
                    maxDate={fromDateMax}
                    type={'text'}
                    dropdownMode="select"
                    includeDates={getDates(true)}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    customInput={<DatePickerCustomButton />}
                    label={'End Date:'}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    name={TransactionSummaryEnum.EndDT}
                    type={'text'}
                    onChange={onChangeOfToDT}
                    minDate={toDateMin}
                    includeDates={getDates(true)}
                    dropdownMode="select"
                  />
                </Grid.Column>
                <Grid.Column
                  floated={'right'}
                  textAlign={'right'}
                  verticalAlign={'middle'}
                  style={{
                    marginTop: 30,
                  }}
                >
                  <Button
                    content="Clear Filters"
                    onClick={clearFilters}
                    type={'button'}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
          <Accordion.Title
            active={activeIndexes.indexOf(1) !== -1}
            index={1}
            onClick={handleCollapsePanelClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Sort By</span>
          </Accordion.Title>
          <Accordion.Content active={activeIndexes.indexOf(1) !== -1}>
            <Grid>
              <Grid.Row columns={2} className={'pt5'}>
                <Grid.Column verticalAlign={'bottom'}>
                  <ReduxFormButtonGroup
                    options={printOptions}
                    value={printOptionsValue}
                    formName={TRANSACTION_SUMMARY_LIST_FORM_NAME}
                    fieldName={TransactionSummaryEnum.PrintOptions}
                    type={'button'}
                  />
                </Grid.Column>
                <Grid.Column floated={'right'} textAlign={'right'}>
                  <Button
                    disabled={fetchTransactionSummaryDateLoading}
                    content="Print"
                    type={'button'}
                    style={{ marginLeft: 10 }}
                    onClick={printTransactionSummary}
                    loading={fetchExistingTranSummaryPrintLoading}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
        <Divider horizontal />
        <Grid>
          <Grid.Row columns={1} className={'remove-spacing'}>
            <Grid.Column>
              <Field
                component={TransactionSummaryGridContainer}
                name={TransactionSummaryEnum.TransactionSummaryGrid}
                {...{
                  data: transactionSummaryDates,
                  loading: fetchTransactionSummaryDateLoading,
                  setReactTableWrapperInstance,
                  reactTableRef,
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}
TransactionSummaryListComponent.propTypes = {
  transactionSummaryDates: PropTypes.array.isRequired,
  onChangeOfFromDT: PropTypes.func,
  fromDateMax: PropTypes.object,
  fromDateMin: PropTypes.object,
  toDateMin: PropTypes.object,
  onChangeOfToDT: PropTypes.func,
  printOptionsValue: PropTypes.string,
  printTransactionSummary: PropTypes.func,
  handleCollapsePanelClick: PropTypes.func,
  activeIndexes: PropTypes.array,
  fetchTransactionSummaryDateLoading: PropTypes.bool,
  fetchExistingTranSummaryPrintLoading: PropTypes.bool,
  clearFilters: PropTypes.func,
  reactTableRef: PropTypes.object,
};
export default TransactionSummaryListComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transactionSummary/components/transactionSummaryList/TransactionSummaryListComponent.js